import * as React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { useTheme } from '@mui/material/styles';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface Props {
    /** Newest first, as the API returns it; the chart shows oldest to newest. */
    data: any[];
}

/** Standard vs expedited production time over the last changes (colors from the theme tokens). */
export default function OrdersTimeGraph({ data }: Props) {
    const theme = useTheme();
    const { color } = theme.custom;
    const ordered = [...data].reverse();
    const labels = ordered.map((item) => new Date(item.timestamp).toLocaleDateString());
    const chartData = {
        labels,
        datasets: [
            {
                label: 'Standard',
                data: ordered.map((item) => parseInt(item.standardProductionTime, 10)),
                borderColor: color.primary.main,
                backgroundColor: color.primary.main,
                tension: 0.25,
                pointRadius: 3,
            },
            {
                label: 'Expedited',
                data: ordered.map((item) => parseInt(item.expeditedProductionTime, 10)),
                borderColor: color.tone.danger.main,
                backgroundColor: color.tone.danger.main,
                tension: 0.25,
                pointRadius: 3,
            },
        ],
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { labels: { color: color.text.secondary, usePointStyle: true } },
            datalabels: { display: false },
        },
        scales: {
            x: { ticks: { color: color.text.secondary }, grid: { color: color.border } },
            y: { ticks: { color: color.text.secondary, precision: 0 }, grid: { color: color.border }, title: { display: true, text: 'Production time', color: color.text.secondary } },
        },
    };
    return <Line data={chartData} options={options as any} />;
}
